export default __webpack_public_path__ + "static/media/Pendant of Shielding.a92dfe39.jpg";